import { FC } from "react"
import ClientsList from "./ClientsList"
import { MainLayout } from "./MainLayout"

export const CustomersPage: FC = () => {
  return (
    <MainLayout>
      <ClientsList />
    </MainLayout>
  )
}
